import { useMemo } from 'react'
import { useNavigate } from 'react-router'

import { AllowedTrandocs } from "./ChargeWorkflow";
import { useHistoryListener } from '../../hooks/useHistoryListener'
import { Charge } from '../../models/Charge'
import { Payment } from '../../models/Payment'
import { currencyFormat } from '../../utils/numbers'
import { formatPhoneNumber } from '../../utils/phone'
import { WorkflowPage } from '../workflows/WorkflowPage'

export function NewChargeCompletePage({
    finalRecord,
    onBackPathName,
    originalRecord,
}: {
    finalRecord: AllowedTrandocs | Charge | Payment
    onBackPathName: string
    originalRecord?: AllowedTrandocs
}) {
    const navigate = useNavigate()
    const { onReset } = WorkflowPage.useResetContainerContext()

    const handleCreateAnother = () => {
        onReset()
        navigate('/charge/new')
    }

    useHistoryListener(() => navigate(onBackPathName))

    const subtitle = useMemo(() => {
        if (finalRecord && 'sendReceipt' in finalRecord && Boolean(finalRecord.sendReceipt)) {
            return `A receipt for ${currencyFormat(finalRecord.chargeAmount, true)} was sent to ${finalRecord.client?.name ?? 'your client'} at ${formatPhoneNumber(finalRecord.client?.e164)}`
        }
        return `${finalRecord.client?.name ?? 'Your client'} was charged ${currencyFormat(finalRecord.chargeAmount, true)}`
    }, [finalRecord])

    const recordType = originalRecord?.recordType ?? finalRecord.recordType
    const recordId = originalRecord?.id ?? finalRecord.id

    return (
        <div className="flex items-center justify-center">
            <div className="max-w-xlarge mt-12">
                {/* <div className="absolute inset-0 mx-20 flex items-center justify-center"> */}
                <WorkflowPage.SuccessView
                    title={'Success'}
                    subtitle={subtitle}
                    links={[
                        {
                            id: 'create-another',
                            onClick: handleCreateAnother,
                            title: 'Create another',
                            subtitle: 'Charge another client',
                            icon: 'plus.large',
                        },
                        {
                            id: 'view',
                            to: `/${recordType}s/${recordId}`,
                            title: `View ${recordType}`,
                            subtitle: `View this ${recordType}`,
                            icon: 'receipt.large',
                        },
                        {
                            id: 'inbox',
                            to: '/messages',
                            title: 'Inbox',
                            subtitle: 'View your inbox',
                            icon: 'message.large',
                        },
                        {
                            id: 'calendar',
                            to: '/calendar',
                            title: 'Calendar',
                            subtitle: 'View your calendar',
                            icon: 'calendar.large',
                        },

                        {
                            id: 'dashboard',
                            to: '/',
                            title: 'Dashboard',
                            subtitle: 'View home screen',
                            icon: 'home.large',
                        },
                    ]}
                />
            </div>
        </div>
    )
}
